<template>
  <v-card class="mx-10 intro-dark align-center justify-center">
    <v-card-title class="justify-center prompt-header py-3">
      <mrx-translation :token="'questions.streamlined_options.prompt'"></mrx-translation>
    </v-card-title>
    <v-card-title class="instructions py-0" id="instructions">
      <mrx-translation :token="'questions.streamlined_options.instructions'"></mrx-translation>
    </v-card-title>

    <multiselect
      class="mb-3"
      sortAlphabetical
      v-model="notPreselected"
      panelName="streamlined"
      panelType="multiple"
      languagePath="streamlined"
      @selectEvent="set"
      >
    </multiselect>

    <div v-if="preselected.length > 0" id="preselected">
      <v-divider></v-divider>
      <span class="intro-dark v-card__title">
        <mrx-translation :token="'questions.streamlined_preselected.prompt'"></mrx-translation>
      </span>
      <ul class="mb-4 v-list-item__title">
        <li class="py-2" v-for="(token, index) in preselected" :key=index>
          <mrx-translation :token="token"></mrx-translation>
        </li>
      </ul>
    </div>

  </v-card>
</template>

<script>
  import MultiSelect from '@/components/inputs/MultiSelect';
  import { mapActions, mapGetters } from 'vuex'

  export default {
    name: 'StreamlinedOption',
    components: {
      multiselect: MultiSelect,
    },
    computed: {
      ...mapGetters({ responses: 'v4/track/streamlinedOptions' }),
      preselected() {
        return this.responses.filter(r => r.preselect).map(r => `responses.${r.name}.title`)
      },
      notPreselected() {
        return this.responses.filter(r => !r.preselect)
      }
    },
    methods: {
      set() {
        // need to wait for the state to update before calling the action
        this.$nextTick(() => { this.setStreamlinedTrack() })
      },
      ...mapActions({
        initialize: 'v4/track/initializeStreamlinedOptions',
        setStreamlinedTrack: 'v4/track/setStreamlinedTrack',
      }),
    },
    async mounted() {
      await this.initialize()
      this.set()
    }
  }
</script>

<style scoped>
ul {
  list-style-type: none;
}
.instructions {
  font-weight: 400;
  font-size: 14px !important;
  color: var(--white-70);
  line-height: 1.5rem;
}
</style>